import { Control, FieldPath, FieldValues } from 'react-hook-form'

import FormGroup from '../../../../core/components/FormGroup'
import { ColorField } from './ColorField'
import type { ColorFormat } from '@/components/ui/color-picker'

export interface GradientFieldProps<T extends FieldValues> {
  control: Control<T>
  baseName: string
  label: string
  fromValue?: string
  toValue?: string
  fromError?: string
  toError?: string
  fallError?: string
  disabled?: boolean
  format?: ColorFormat
}

export function GradientField<T extends FieldValues>({
  control,
  baseName,
  label,
  fromValue,
  toValue,
  fromError,
  toError,
  fallError,
  disabled,
  format,
}: GradientFieldProps<T>) {
  return (
    <>
      <FormGroup label={label}>
        <div className="flex w-full items-end gap-2">
          <div className="bg-monochrome-120 border border-monochrome-120 rounded-2xl h-[44px] w-[44px] shrink-0 items-center justify-center flex">
            <div
              className="rounded-full w-[24px] h-[24px] border border-monochrome-120 flex-shrink-0"
              style={{
                background: `linear-gradient(${fromValue} , ${toValue})`,
              }}
            />
          </div>

          <ColorField
            control={control}
            name={`${baseName}.from` as FieldPath<T>}
            error={fromError}
            disabled={disabled}
            format={format}
          />
          <ColorField
            control={control}
            name={`${baseName}.to` as FieldPath<T>}
            error={toError}
            disabled={disabled}
            format={format}
          />
        </div>
      </FormGroup>
      <ColorField
        control={control}
        name={`${baseName}.fallBackColor` as FieldPath<T>}
        label="Fall Color"
        error={fallError}
        disabled={disabled}
        format={format}
      />
    </>
  )
}
